export default __webpack_public_path__ + "i18n/translations/translation-ta.e83187dd.json";